import { createContext } from "react";
const inventoryContext = createContext();
export default inventoryContext;
